// extracted by mini-css-extract-plugin
module.exports = {"never":"Featured_never__WhYqE","gn":"Featured_gn__G5T9v","image":"Featured_image__oFxsi"};